import React from 'react'
import { AnovaLogo } from './AnovaLogo'
import { CardOverlay } from './styled-components/Card'
import styled from 'styled-components'
import CircularProgress from '@material-ui/core/CircularProgress'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import { colors } from './styled-components/defaultTheme'

const lightGray = {
  50: colors.lightGray,
  100: colors.lightGray,
  200: colors.lightGray,
  300: colors.lightGray,
  400: colors.lightGray,
  500: colors.lightGray,
  600: colors.lightGray,
  700: colors.lightGray,
  800: colors.lightGray,
  900: colors.lightGray,
  A100: colors.lightGray,
  A200: colors.lightGray,
  A400: colors.lightGray,
  A700: colors.lightGray
}

const theme = createMuiTheme({
  palette: {
    primary: lightGray
  },
  typography: { useNextVariants: true }
})

const LoadingIndicatorTopMargin = styled.div`
    margin-top: 130px;
`

const LoadingIndicator = () => {
  return (
    <CardOverlay>
      <AnovaLogo />
      <LoadingIndicatorTopMargin>
        <MuiThemeProvider theme={theme}>
          <CircularProgress />
        </MuiThemeProvider>
      </LoadingIndicatorTopMargin>
    </CardOverlay>
  )
}

export default LoadingIndicator
